import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=7fa2729f&scoped=true&"
import script from "./Attributes.vue?vue&type=script&lang=js&"
export * from "./Attributes.vue?vue&type=script&lang=js&"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=7fa2729f&scoped=true&lang=scss&"
import style1 from "./Attributes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2729f",
  null
  
)

export default component.exports